import { adjustAllocateBin, audit, batchAudit, effect, finish, get, getByidAndFilter, getByNumber, getItem, getServerDate, groupWithNum, modify, modifyCollectBin, modifyOperate, modifyPicker, modifyPickType, normalAudit, page, pagePickGroupTask, pickqtyadj, pickqtyadjQuery, print, printElectronicLabel, printLabel, printPickGroupTask, query, queryAllocateBinDashboard, queryElectronicRecord, queryItemsByPIAId, queryItemsByStore, queryUnifyStoreCollectBinInfo, realPrintLabelaudit, recalculate, releasePickGroupTask, save as saveItem, storeCollectBinpage, updateItem, verifyBin } from '@/services/forward/out/PickUp';
import { formatMessage } from 'umi/locale';

export default {
  namespace: 'pickup',
  subscriptions: {
    /**
     * 监听浏览器地址
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.payload && location.pathname == "/out/pickup") {
          dispatch({
            type: 'showPage',
            payload: location.payload,
          })
        }
      });
    },
  },
  state: {
    data: {
      list: [],
      pagination: {},
    },
    adjData: { //拣货数量调整
      list: [],
      pagination: {},
    },
    entity: {},
    printList: [],
    electronicList: [],
    showPage: 'query',
  },
  effects: {
    *queryItemsByPIAId({ payload, callback }, { call, put }) {
      const response = yield call(queryItemsByPIAId, payload);
      if (callback) callback(response);
    },
    *queryItemsByStore({ payload, callback }, { call, put }) {
      const response = yield call(queryItemsByStore, payload);
      if (callback) callback(response);
    },
    *getByidAndFilter({ payload, callback }, { call, put }) {
      const response = yield call(getByidAndFilter, payload);
      if (callback) callback(response);
    },
    *effect({ payload, callback }, { call, put }) {
      const response = yield call(effect, payload);
      if (callback) callback(response);
    },
    *finish({ payload, callback }, { call, put }) {
      const response = yield call(finish, payload);
      if (callback) callback(response);
    },
    *page({ payload, callback }, { call, put }) {
      const response = yield call(page, payload);
      if (callback) callback(response);
    },
    *storeCollectBinpage({ payload, callback }, { call, put }) {
      const response = yield call(storeCollectBinpage, payload);
      if (callback) callback(response);
    },
    *getItem({ payload, callback }, { call, put }) {
      const response = yield call(getItem, payload);
      if (callback) callback(response);
    },
    *saveItem({ payload, callback }, { call, put }) {
      const response = yield call(saveItem, payload);
      if (callback) callback(response);
    },
    *verifyBin({ payload, callback }, { call, put }) {
      const response = yield call(verifyBin, payload);
      if (callback) callback(response);
    },
    *updateItem({ payload, callback }, { call, put }) {
      const response = yield call(updateItem, payload);
      if (callback) callback(response);
    },
    *audit({ payload, callback }, { call, put }) {
      const response = yield call(audit, payload);
      if (response && response.success) {
        yield put({
          type: 'onShowPage',
          showPage: 'view',
          entityUuid: payload.uuid
        });
      }
      if (callback) callback(response);
    },
    *modify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (response && response.success) {
        yield put({
          type: 'onShowPage',
          showPage: 'view',
          entityUuid: payload.uuid
        });
      }
      if (callback) callback(response);
    },
    *normalAudit({ payload, callback }, { call, put }) {
      const response = yield call(normalAudit, payload);
      if (callback) callback(response);
    },
    *modifyOperate({ payload, callback }, { call, put }) {
      const response = yield call(modifyOperate, payload);
      if (callback) callback(response);
    },

    *batchAudit({ payload, callback }, { call, put }) {
      const response = yield call(batchAudit, payload);
      if (callback) callback(response);
    },
    *queryForSelect({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
    },
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);

      if (response && response.success && response.data) {
        yield put({
          type: 'save',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            }
          },
        });
      }
    },
    *queryApprovedBill({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
    },
    *pickqtyadjQuery({ payload, callback }, { call, put }) {
      const response = yield call(pickqtyadjQuery, payload);
      if (callback) callback(response);

      if (response && response.success && response.data) {
        yield put({
          type: 'saveAdjData',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            }
          },
        });
      }
    },
    *pickqtyadj({ payload, callback }, { call, put }) {
      const response = yield call(pickqtyadj, payload);
      if (callback) callback(response);
    },
    *get({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      if (response && response.success) {
        yield put({
          type: 'onView',
          entity: response.data
        });
      }
      if (callback) callback(response);
    },
    *modifyPicker({ payload, callback }, { call, put }) {
      const response = yield call(modifyPicker, payload);
      if (callback) callback(response);
    },
    *printLabel({ payload, callback }, { call, put }) {
      const response = yield call(printLabel, payload);
      if (callback) callback(response);
    },
    *queryPrintRecord({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (response && response.success) {
        yield put({
          type: 'onPrintList',
          list: response.data && response.data.records ? response.data.records : []
        });
      }
      if (callback) callback(response);
    },
    *queryElectronicRecord({ payload, callback }, { call, put }) {
      const response = yield call(queryElectronicRecord, payload);
      if (response && response.success) {
        yield put({
          type: 'onElectronicList',
          list: response.data ? response.data : []
        });
      }
      if (callback) callback(response);
    },
    *printElectronicLabel({ payload, callback }, { call, put }) {
      const response = yield call(printElectronicLabel, payload);
      if (callback) callback(response);
    },
    *recalculate({ payload, callback }, { call, put }) {
      const response = yield call(recalculate, payload);
      if (callback) callback(response);
    },
    *getServerDate({ payload, callback }, { call, put }) {
      const response = yield call(getServerDate);
      if (callback) callback(response);
    },
    *showPage({ payload }, { call, put }) {
      yield put({
        type: 'onShowPage',
        showPage: payload.showPage,
        entityUuid: payload.entityUuid,
        billNumber: payload.billNumber,
        waveBillNumber: payload.waveBillNumber,
      });
    },
    *getByNumber({ payload, callback }, { call, put }) {
      const response = yield call(getByNumber, payload);
      if (response && response.success) {
        yield put({
          type: 'onView',
          entity: response.data
        });
      }
      if (callback) callback(response);
    },
    *queryWavePickUp({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);

      if (response && response.success && response.data) {
        yield put({
          type: 'savePickUp',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            }
          },
        });
      }
    },
    *queryAllocateBinDashboard({ payload, callback }, { call, put }) {
      const response = yield call(queryAllocateBinDashboard, payload);
      if (response && response.success && response.data) {
        yield put({
          type: 'saveAllocateBins',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },
    *adjustAllocateBin({ payload, callback }, { call, put }) {
      const response = yield call(adjustAllocateBin, payload);
      if (callback) callback(response);
    },
    *queryUnifyStoreCollectBinInfo({ payload, callback }, { call, put }) {
      const response = yield call(queryUnifyStoreCollectBinInfo, payload);
      if (response && response.success && response.data) {
        yield put({
          type: 'saveCollectBins',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },
    *modifyCollectBin({ payload, callback }, { call, put }) {
      const response = yield call(modifyCollectBin, payload);
      if (callback) callback(response);
    },
    *modifyPickType({ payload, callback }, { call, put }) {
      const response = yield call(modifyPickType, payload);
      if (callback) callback(response);
    },
    *print({ payload, callback }, { call, put }) {
      const response = yield call(print, payload);
      if (callback) callback(response);
    },
    *groupWithNum({ payload, callback }, { call, put }) {
      const response = yield call(groupWithNum, payload);
      if (callback) callback(response);
    },
    *pagePickGroupTask({ payload, callback }, { call, put }) {
      const response = yield call(pagePickGroupTask, payload);
      if (callback) callback(response);
    },
    *releasePickGroupTask({ payload, callback }, { call, put }) {
      const response = yield call(releasePickGroupTask, payload);
      if (callback) callback(response);
    },
    *printPickGroupTask({ payload, callback }, { call, put }) {
      const response = yield call(printPickGroupTask, payload);
      if (callback) callback(response);
    },
    *realPrintLabelaudit({ payload, callback }, { call, put }) {
      const response = yield call(realPrintLabelaudit, payload);
      if (callback) callback(response);
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    saveAdjData(state, action) {
      return {
        ...state,
        adjData: action.payload,
      };
    },
    onView(state, action) {
      return {
        ...state,
        entity: action.entity,
        billNumber: undefined,
        entityUuid: undefined
      }
    },
    onPrintList(state, action) {
      return {
        ...state,
        printList: action.list
      }
    },
    onElectronicList(state, action) {
      return {
        ...state,
        electronicList: action.list
      }
    },
    onShowPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        entityUuid: action.entityUuid,
        billNumber: action.billNumber,
        waveBillNumber: action.waveBillNumber,
        adjData: action.showPage === 'adjPage' ? state.adjData : {
          list: [],
          pagination: {},
        }
      }
    },
    savePickUp(state, action) {
      return {
        ...state,
        wavePickUpData: action.payload,
      };
    },
    saveAllocateBins(state, action) {
      return {
        ...state,
        allocateBins: action.payload,
      };
    },
    saveCollectBins(state, action) {
      return {
        ...state,
        collectBins: action.payload,
      };
    },
  }
}
